import { useRouter } from "next/router";
import useSWR from "swr";
import axios from "../../Axios";

const useLocaleSWR = (url) => {
  const router = useRouter();
  const { locale } = router;

  const shouldFetch = typeof locale === "string";

  const { data, error } = useSWR(shouldFetch ? url : null, axios.get);

  return { data, error };
};

export default useLocaleSWR;